/** @jsxImportSource @emotion/react */

import { Pagination } from "antd";

import { PaginationTableStyle } from "./index.style";

interface Props {
  lengthData: number;
  page: number;
  pageSize: number;
  total: number;
  onChangePage: (pagePagination: number) => void;
}
const PaginationTable: React.FC<Props> = ({
  lengthData,
  page,
  pageSize,
  total,
  onChangePage,
}) => {
  return (
    <>
      {(lengthData || 0) > 0 && (
        <div css={PaginationTableStyle.boxPagination}>
          <Pagination
            css={PaginationTableStyle.paginationStyle}
            current={page}
            pageSize={pageSize}
            total={total}
            onChange={(page: number) => onChangePage(page)}
            showSizeChanger={false}
          />
        </div>
      )}
    </>
  );
};

export default PaginationTable;
